// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { DAMAGE_CASE_REMEMBER_DRAWING } from "./constants"

export function rememberDrawing(caseId, pictureNr, drawingData) {
  return {
    type: DAMAGE_CASE_REMEMBER_DRAWING,
    data: { caseId, pictureNr, drawingData },
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case DAMAGE_CASE_REMEMBER_DRAWING:
      const { caseId, pictureNr, drawingData } = action.data
      const damageCase = state.unsentCases[caseId]
      const pictures = damageCase.pictures.map((picture, idx) => {
        if (idx === pictureNr - 1) {
          return { ...picture, drawingData }
        } else {
          return picture
        }
      })
      const alteredCase = { ...damageCase, pictures }
      return {
        ...state,
        unsentCases: { ...state.unsentCases, [caseId]: alteredCase },
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/features/damage-case/redux/rememberDrawing.js